
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["tempDerateListb_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 736a224 224 0 11224 224 224 224 0 01-224-224zm192-128v128a32.512 32.512 0 009.472 22.656l64 64a31.488 31.488 0 0045.184 0 30.656 30.656 0 009.472-22.528 31.168 31.168 0 00-9.472-22.528l-54.528-54.656V608.128a32 32 0 00-64 0zM116.16 896a52.032 52.032 0 01-51.968-51.968A364.8 364.8 0 01306.88 505.344a242.816 242.816 0 11348.352-77.632A316.16 316.16 0 00460.48 896z"}})])
          )
        }
      }
    